import { useEffect, useState } from 'react'

const MOBILE_BREAKPOINT_PX = 768

export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState<boolean>(() => {
    if (typeof window === 'undefined') return false
    return window.matchMedia(
      '(max-width: ' + (MOBILE_BREAKPOINT_PX - 1) + 'px)',
    ).matches
  })

  useEffect(() => {
    if (typeof window === 'undefined') return
    const mql = window.matchMedia(
      '(max-width: ' + (MOBILE_BREAKPOINT_PX - 1) + 'px)',
    )
    const handler = (event: MediaQueryListEvent) => setIsMobile(event.matches)
    mql.addEventListener('change', handler)
    return () => mql.removeEventListener('change', handler)
  }, [])

  return isMobile
}
